import React from 'react'
import { GraphTemplate } from '../../models/GraphTemplateModel'
import { ImportedData } from './GraphUtilityFunctions'
import { Strip, Label, Font } from 'devextreme-react/chart';
import moment from 'moment'

export const renderImportedDataStrips = (
    unitsAndValues: GraphTemplate[],
    importData: ImportedData
): React.ReactNode => {
    const renderStrips: React.ReactNode[] = []
    const set = unitsAndValues[0]?.graphSettings
    if (importData && set) {
        if (importData.A.length > 0) {
            importData.A.forEach((item, idx) => {
                renderStrips.push(
                    <Strip startValue={moment(item.start).toDate()} endValue={moment(item.end).toDate()} color={`${set.flowAColor}40`} >
                        <Label text={idx > 0 ? "" : "Imported Data"} verticalAlignment='bottom' rotationAngle={90}><Font color={`${set.flowAColor}`} /></Label>
                    </Strip>)
            })
        }
        if (importData.B.length > 0) {
            importData.B.forEach((item, idx) => {
                renderStrips.push(
                    <Strip startValue={moment(item.start).toDate()} endValue={moment(item.end).toDate()} color={`${set.flowBColor}40`} >
                        <Label text={idx > 0 ? "" : "Imported Data"} verticalAlignment='bottom' rotationAngle={90}><Font color={`${set.flowBColor}`} /></Label>
                    </Strip>)
            })
        }
        if (importData.C.length > 0) {
            importData.C.forEach((item, idx) => {
                renderStrips.push(
                    <Strip startValue={moment(item.start).toDate()} endValue={moment(item.end).toDate()} color={`${set.pressureCColor}40`} >
                        <Label text={idx > 0 ? "" : "Imported Data"} verticalAlignment='bottom' rotationAngle={90}><Font color={`${set.pressureCColor}`} /></Label>
                    </Strip>)
            })
        }
        if (importData.D.length > 0) {
            importData.D.forEach((item, idx) => {
                renderStrips.push(
                    <Strip startValue={moment(item.start).toDate()} endValue={moment(item.end).toDate()} color={`${set.pressureDColor}40`} >
                        <Label text={idx > 0 ? "" : "Imported Data"} verticalAlignment='bottom' rotationAngle={90}><Font color={`${set.pressureDColor}`} /></Label>
                    </Strip>)
            })
        }
        if (importData.E.length > 0) {
            importData.E.forEach((item, idx) => {
                renderStrips.push(
                    <Strip startValue={moment(item.start).toDate()} endValue={moment(item.end).toDate()} color={`${set.pressureEColor}40`} >
                        <Label text={idx > 0 ? "" : "Imported Data"} verticalAlignment='bottom' rotationAngle={90}><Font color={`${set.pressureEColor}`} /></Label>
                    </Strip>)
            })
        }
    }
    console.log(renderStrips)
    return renderStrips
}